import PropTypes from "prop-types";
import React from "react";
import { intlShape } from "react-intl";
import { Checkbox } from "cxa-components";
import FormField from "./FormField";
import { localise } from "./util";

const renderCheckboxes = ({
  onChange,
  onBlur,
  items,
  valueKey = "value",
  labelKey = "label",
  value,
  id,
  intl,
  ...rest
}) =>
  <div>
    {items.map((item, i) =>
      <Checkbox
        id={`${id}-${i}`}
        key={item[valueKey]}
        value={item[valueKey]}
        checked={value[item[valueKey]] || false}
        onChange={e =>
          onChange({ ...value, [item[valueKey]]: e.target.checked })}
        onBlur={e => onBlur({ ...value, [item[valueKey]]: e.target.checked })}
        {...rest}
      >
        {React.isValidElement(item[labelKey])
          ? item[labelKey]
          : localise(item[labelKey], intl)}
      </Checkbox>
    )}
  </div>;

renderCheckboxes.propTypes = {
  items: PropTypes.array,
  valueKey: PropTypes.string,
  labelKey: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  id: PropTypes.string,
  intl: intlShape.isRequired,
};

const Checkboxes = props =>
  <FormField component={renderCheckboxes} {...props} />;

export default Checkboxes;



// WEBPACK FOOTER //
// ./components/common/form-field/Checkboxes.js